/**
 * XSS攻撃やインジェクション攻撃を防ぐための入力検証
 */

export const validateEmailFormat = (email: string): boolean => {
  if (!email || typeof email !== 'string') {
    return false
  }

  const parts = email.split('@')
  if (parts.length !== 2) {
    return false
  }

  const localPart = parts[0]
  const domainPart = parts[1]

  if (localPart.includes('..') || domainPart.includes('..')) {
    return false
  }

  // ローカル部がドット、アンダースコア、ハイフンで始まったり終わったりしないことを確認
  if (/^[._-]|[._-]$/.test(localPart)) {
    return false
  }

  // 許可: 英数字、ドット、アンダースコア、ハイフン
  const localPartRegex = /^[a-zA-Z0-9._-]+$/
  const domainPartRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  return localPartRegex.test(localPart) && domainPartRegex.test(domainPart)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const emailValidator = (_rule: any, value: string): Promise<void> => {
  if (!value) {
    return Promise.reject(new Error('Email is required!'))
  }

  if (!validateEmailFormat(value)) {
    return Promise.reject(
      new Error('Please enter a valid email address.')
    )
  }

  return Promise.resolve()
}
